import type {DaoCategory} from "../../daos/dao-category.ts";
import _ from "lodash";
import {useEffect, useState} from "react";

interface MenuVoiceProps {
  callback?: (menu: DaoCategory) => void,
  menu?: DaoCategory | undefined
}

function MenuAiVoice({callback, menu}: MenuVoiceProps) {
  const [aiVoice, setAiVoice] = useState<DaoCategory | undefined>(menu);
  const menus: DaoCategory[] = [{no: 'announce', name: '바로 재생'}, {no: 'history', name: '재생 내역'}];

  useEffect(() => {
    setAiVoice(menu);
  }, [menu]);

  function aiVoiceChangeHandler(menu: DaoCategory): void {
    if (!_.isEqual(menu, aiVoice)) {
      setAiVoice(menu);
      if (_.isFunction(callback)) {
        callback.call(null, menu);
      }
    }
  }

  useEffect(() => {
    if (menus.length > 0) {
      aiVoiceChangeHandler(menus[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="category">
      <div className="category-list">
        {menus.map((item: DaoCategory) => (
          <div className="category-item" key={item.no}><a onClick={() => aiVoiceChangeHandler(item)}
                                                          className={(aiVoice && _.isEqual(aiVoice.no, item.no)) ? 'on' : ''}>{item.name}</a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MenuAiVoice;